
export class Saseung3 {
  id: string | null;
  hangul: string;
  hanja: string;
  four_tones: string;
  meaning: string;
  order1: string;
  bookmark: boolean;

  constructor(obj?: any) {
    this.id         = (obj && obj.id)         ?? null;
    this.hangul     = (obj && obj.hangul)     ?? '';
    this.hanja      = (obj && obj.hanja)      ?? '';
    this.four_tones = (obj && obj.four_tones) ?? '';
    this.meaning    = (obj && obj.meaning)    ?? '';
    this.order1     = (obj && obj.order1)     ?? '';
    this.bookmark   = Boolean((obj && obj.bookmark) ?? false);
  }
}
